import React from "react";
import { ModalSearchSignatureBackgroundProps } from "./interface";
import { SignatureBackground } from "../../generated/graphql";
import DefaultModal from "../ModalDefault";
import TableSignatureBackground from "../TableSignatureBackground";

const ModalSearchSignatureBackground: React.FC<
  ModalSearchSignatureBackgroundProps
> = ({ onSelect, ...props }) => {
  return (
    <DefaultModal
      {...props}
      contentMaxW="1080px"
      title="Search Signature Background"
      hideFooter
    >
      <TableSignatureBackground
        tableContainerProps={{
          maxH: "calc(100vh - 280px)",
          overflow: "auto",
        }}
        columnVisibility={{
          isDefault: false,
          enable: false,
        }}
        activeOnly
        hasRowSelection
        onSelect={(signatureBackground) => {
          onSelect(signatureBackground as SignatureBackground);
        }}
      />
    </DefaultModal>
  );
};

export default ModalSearchSignatureBackground;
